import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { useCheckPaymentExpiration, useGetPaymentMethods } from '~/domain/Payments';
import {
  enablePaymentExpirationReminders,
  getHideNotificationsOnParentOffice,
} from '~/growthbook';

export const usePaymentExpiration = () => {
  const isEnablePaymentExpiration = useRef(enablePaymentExpirationReminders()).current;
  const isHideNotificationsOnParentOffice = useRef(getHideNotificationsOnParentOffice()).current;

  const user = useSelector((state) => state.user.selectedChildOffice || state.user.user);
  const isParentOffice = useSelector(
    (state) =>
      (state.user?.selectedChildOffice?.childOffices || state.user?.childOffices)?.length > 1,
  );
  const isParentOfficeAndHideNotificationsOnParentOffice =
    isParentOffice && isHideNotificationsOnParentOffice;
  const shouldFetchPayments = Boolean(
    isEnablePaymentExpiration &&
    !user?.is_pre_approved &&
    !isParentOfficeAndHideNotificationsOnParentOffice,
  );
  const { isLoading } = useGetPaymentMethods(undefined, {
    enabled: shouldFetchPayments,
  });

  const { isExpired, isExpiring } = useCheckPaymentExpiration();

  if (!isEnablePaymentExpiration || isParentOfficeAndHideNotificationsOnParentOffice) {
    return {
      isLoading: false,
      isPaymentExpired: false,
      isPaymentExpiring: false,
    };
  }

  return {
    isLoading,
    isPaymentExpired: !isLoading && !user?.is_pre_approved && isExpired,
    isPaymentExpiring: !isLoading && !user?.is_pre_approved && isExpiring,
  };
};
